export default {
  label: 'Interações',
  placeholder: 'Indiferente',
  selected: 'selecionado',
  selectedPlural: 'selecionados',
};
